module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-34-35-034.812960f7.mp4";